import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { routerReducer } from 'react-router-redux';

import pages from './pages';
import contents from './contents';
import catalog from './catalog';
import platforms from './platforms';
import deployments from './deployments';

export default combineReducers({
  form: formReducer,
  toastr: toastrReducer,
  router: routerReducer,
  pages,
  contents,
  catalog,
  platforms,
  deployments,
});



// WEBPACK FOOTER //
// ./src/modules/catalog/reducers/index.js